import { buildUrl } from '../../../common/urlBuilder';
import Service from '../../../service';

export const getCityList = async (stateId) => {
  let url = buildUrl('v1/site-management/city');
  if (stateId) url += `?stateId=${stateId}`;

  return Service.get(url);
};

export const getAll = async (filteredData) => {
  let url = buildUrl('v1/site-management/customer/pagination');
  if (filteredData) url += `?${filteredData}`;

  return Service.get(url);
};

export const findCustomerDetails = async (id) => {
  let url = buildUrl(`v1/site-management/customer/${id}`);

  return Service.get(url);
};

export const create = async (data) => {
  let url = buildUrl('v1/site-management/customer');

  return Service.post(url, data);
};

export const update = async (data, id) => {
  let url = buildUrl(`v1/site-management/customer/${id}`);
  return Service.put(url, data);
};

export const deleteCustomer = async (id) => {
  let url = buildUrl(`v1/site-management/customer/${id}`);
  return Service.delete(url);
};